'use strict'

var newify = require('newify')
var curry  = require('./curry')

module.exports = curry(newify)


/*****************
 ** WEBPACK FOOTER
 ** ./~/functionally/src/newify.js
 ** module id = 847
 ** module chunks = 0
 **/